export const CRBN_ORANGE_LOGO = "/media/logos/crbn_logo_orange.png"
export const CUSTOM_CRBN_LOGO = "/media/logos/custom_crbn_logo.png"
export const EXTERNAL_LOGO = "/media/logos/external.png"
export const TEAM_PROGRAM_LOGO = "/media/logos/team_program.png"
export const CRBN_SQUARE_LOGO = "/media/logos/crbn_logo_square.png"
export const WELCOME_BACKGROUND = "/media/logos/welcome_background.png"
// DESIGN PAGE
export const NEW_DESIGN_PLACEHOLDER = "/media/placeholders/DESIGN_CHOOSE_TEMPLATE.jpg"
export const IMAGE_PLACEHODLER = '/media/placeholders/IMAGE_PLACEHOLDER.svg'
export const RENDER_REFERENCE_PLACEHOLDER = "/media/placeholders/RENDER_REFERENCE_PLACEHOLDER.png"
export const RENDER_LOGO_PLACEHOLDER =  "/media/placeholders/RENDER_LOGO_PLACEHOLDER.png"
export const DESIGN_PLACEHOLDER_VIDEO = "/media/placeholders/DESIGN_VIDEO_PLACEHOLDER.mp4"
export const DESIGN_REQUEST_INFORMATION = '/media/placeholders/DESIGN_REQUEST_INFORMATION.gif'
export const DESIGN_PLACEHOLDER_IMAGE = '/media/placeholders/DESIGN_IMAGE_PLACEHOLDER.png'

// STRING REUUIRE TO SHOW ALLOWED TYPES ON THE INPUT
export const ALLOWED_FILETYPES_STRING = ".AI, .EPS, .PDF, .JPG, .JPEG, .PNG, .PSD, .WEBP"
export const ALLOWED_FILETYPES = ["AI", "EPS", "PDF", "JPG", "JPEG", "PNG", "PSD", "WEBP"]

// ICONS
export const ICON_CLOSE = "/media/icons/icons8-close.svg"
export const ICON_CLOSE_X = "/media/icons/close_x.png" // use in modal to close

// SERVER BASE PATH
//export const SERVER_BASE_PATH = "http://localhost:8000"
export const SERVER_BASE_PATH = "https://taiwan.crbnpaintball.com"
// MONEY FORMAT
export const MONEY = new Intl.NumberFormat("en-US", { style: "currency", currency: "usd" });


// TEAM LOGO REQUIREMENTS
export const SMALL_TEAM_LOGO_SIZE = { width: 500, height: 250 }
export const NORMAL_TEAM_LOGO_SIZE = { width: 3000, height: 1500 }
export const MONO_TEAM_LOGO_SIZE = { width: 3000, height: 1500 }


// RX LENS PLACEHOLDER
export const RX_LENS_PLACEHOLDER = "/media/placeholders/RX_LENS_IMAGE.webp"

// How many items to fetch per page
export const MAX_ADMIN_PAGE_LIMIT = 30

export type RouteParams = {
  id: string;
};
export const FOOTER_TERMS_URL = "https://crbnpaintball.com/pages/terms-privacy"




